import { render, staticRenderFns } from "./ListagemFaturas.vue?vue&type=template&id=7d8ae6ba&scoped=true"
import script from "./ListagemFaturas.vue?vue&type=script&lang=js"
export * from "./ListagemFaturas.vue?vue&type=script&lang=js"
import style0 from "./ListagemFaturas.vue?vue&type=style&index=0&id=7d8ae6ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8ae6ba",
  null
  
)

export default component.exports